<template lang="pug">
.banner.bg-cover.visible-xs
div#selected-company(v-if="$parent.selectedCompany", @click="$parent.selectCompanyToggle=true")
  | {{$parent.selectedCompany | multilang}}
  span.company-select-icon
    i.fa.fa-angle-left.fa-2x
section.pt0
  .container
    .row
      .col-xs-12
        .media(v-for="row in rows")
          .media-left
            a(@click.prevent='showDetail(row.job_id)')
              img.media-object(':src'="row.company.thumbnail_image | resource")
          .media-body.media-middle
            h4.media-heading.hidden-xs
              a(@click.prevent='showDetail(row.job_id)' target="_blank") {{row.company.name | multilang}} &nbsp; | &nbsp; {{'JOB_POST_DATE' | wordDict}}: {{row.ctime | moment 'D MMMM YYYY'}}
            p {{row.title | multilang}}
            h4.media-heading.visible-xs
              div
                a(@click.prevent='showDetail(row.job_id)' target="_blank") {{row.company.name | multilang}}
              div
                a(@click.prevent='showDetail(row.job_id)' target="_blank") {{'JOB_POST_DATE' | wordDict}}: {{row.ctime | moment 'D MMMM YYYY'}}
</template>

<script>
import  router from './../../router'
import axios from 'axios'

export default {
  data () {
    return {
      url: '/api/jobs',
      data: {},
      rows: [],
    }
  },
  computed: {
    category: function() {
      return this.$route.params.category;
    },
  },
  created () {
    this.reload();
  },
  watch: {
    category(val) {
      this.reload();
    },
  },
  ready () {},
  methods: {
    showDetail: function(jobId) {
      router.go(`/job/detail/${jobId}`);
    },
    reload: function() {
      let category = this.category;
      let params = {};
      if (category=='technology') {
        params.category = 'Technology';
      } else if (category=='media') {
        params.category = 'N-S Media';
      } else if (category=='lifestyle' || category=='entertainment') {
        params.category = 'E&S';
      } else if (category=='food' || category=='beverage') {
        params.category = 'F&B';
      } else if (category=='company') {
        params.company_id = this.$route.params.id;
      }
      axios.get(this.url, {params})
      .then((response) => {
        const data = response.data
        this.rows = response.data.results
      }).catch((err) => console.log(err));
    },
  },
  components: {},
}
</script>

<style lang="scss" scoped>
@import "global";

.menus {
  h4 {
    font-size: 20px;
  }
  margin-bottom: 30px;
}

.media {
  @media(max-width: #{$screen-xs-max}) {
    margin-top: 18px;
    padding-bottom: 17px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
}

.media-left {
  @media(max-width: #{$screen-xs-max}) {
    padding-right: 16px;
  }
  padding-right: 85px;
}

.media-heading {
  div {
    @media(max-width: #{$screen-xs-max}) {
      height: 16px;
    }
  }
  a {
    @media(max-width: #{$screen-xs-max}) {
      font-size: 12px;
    }
    font-size: 16px;
    color: #6a869c;
  }
}

.media-body {
  font-weight: bold;
  font-size: 20px;
  p {
    @media(max-width: #{$screen-xs-max}) {
      margin: 0 0 5px;
      height: 19px;
      font-size: 14px;
      overflow: hidden;
    }
  }
}

.media-object {
  width: 110px;
  height: 110px;
  @media(max-width: #{$screen-xs-max}) {
    width: 60px;
    height: 60px;
  }
  background-color: gray;
  border-radius: 220px;
}

.banner {
  height: 166px;
  background-image: url('../../images/job/Full_4_Career.jpg');
  @media(max-width: #{$screen-xs-max}) {
    margin-bottom: 28px;
  }
}

a {
  cursor: pointer;
}

section.pt0 {
  @media(min-width: #{$screen-md-min}) {
    padding-left: 200px;
  }
  .container {
    @media(max-width: #{$screen-xs-max}) {
      margin-top: 0;
    }
  }
}
#selected-company {
  display: none;
}
@media(max-width: $grid-float-breakpoint-max) {
  #selected-company {
    display: block;
    position: relative;
    background-color: #003471;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding: 16px 4px;
    margin-top: -28px;
    text-align: center;
    .company-select-icon {
      display: block;
      position: absolute;
      top: 5px;
      right: 22px;
      height: 52px;
      z-index: 1;
      font-size: 14px;
      line-height: 52px;
      text-align: center;
      > i {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// jobs.vue?29fab0c0